import { cn } from '../../utils/cn';

/** Scrim permanente sobre a imagem de visão — legibilidade de pills/texto (.pen ds/card/goal-vision-hero). */
export const VISION_SCRIM_CLASS =
  'absolute inset-0 bg-[linear-gradient(180deg,theme(colors.vision.scrim-top)_0%,theme(colors.vision.scrim-from)_34%,theme(colors.vision.scrim-mid)_62%,theme(colors.vision.scrim-to)_100%)]';

export function GoalVisionImage({ imageUrl, alt = '', className, groupClassName }) {
  if (imageUrl) {
    return (
      <img src={imageUrl} alt={alt} className={cn('h-full w-full object-cover', className)} />
    );
  }

  if (groupClassName) {
    return <div className={cn('h-full w-full', groupClassName, className)} aria-hidden />;
  }

  return (
    <div
      className={cn('h-full w-full bg-gradient-to-br from-vision-fallback-from to-vision-fallback-to', className)}
      aria-hidden
    />
  );
}
